import { ISuggestionEntryMixin } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import {
  getTopResultsHeader,
  getRecentlyViewedHeader,
  getTrendingBrandsHeader,
  getBrandsHeader,
  getSuggestedTermsHeader,
  RESULT_DROPDOWN_SVG_ICON_PROPS,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import { ResultDropdownImageItem } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageItem";
import { ResultDropdownImageSearchItem } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageSearchItem";
import { Search } from "@faire/slate/icons/Search";
import { useStrictLocalization } from "@faire/web/common/localization";

interface ITypeaheadStateItemComponentProps {
  sectionHeader: string;
  suggestion: ISuggestionEntryMixin;
  onHover: (indx: number) => void;
  onMouseLeave: () => void;
  onClick: () => void;
  selected: number;
  indx: number;
  shouldEnableSuggestionsImpressionAllocationV2: boolean;
  query: string;
}

export const TypeaheadStateSections = ({
  sectionHeader,
  suggestion,
  onHover,
  onMouseLeave,
  onClick,
  selected,
  indx,
  shouldEnableSuggestionsImpressionAllocationV2,
  query,
}: ITypeaheadStateItemComponentProps) => {
  const { strictLocalize } = useStrictLocalization();
  const isProductSection =
    sectionHeader === getTopResultsHeader(strictLocalize) ||
    sectionHeader === getRecentlyViewedHeader(strictLocalize);
  const isBrandSection =
    sectionHeader === getTrendingBrandsHeader(strictLocalize) ||
    sectionHeader === getBrandsHeader(strictLocalize);

  if (isProductSection || isBrandSection) {
    return (
      <ResultDropdownImageItem
        selected={indx === selected}
        index={indx}
        onHover={onHover}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        suggestion={suggestion}
        isProduct={isProductSection}
        shouldEnableSuggestionsImpressionAllocationV2={
          shouldEnableSuggestionsImpressionAllocationV2
        }
      />
    );
  }

  if (sectionHeader === getSuggestedTermsHeader(strictLocalize)) {
    return (
      <ResultDropdownImageSearchItem
        onHover={() => onHover(indx)}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        suggestion={suggestion}
        image={<Search {...RESULT_DROPDOWN_SVG_ICON_PROPS} />}
        reverseHighlightText={query}
        selected={indx === selected}
        shouldEnableSuggestionsImpressionAllocationV2={
          shouldEnableSuggestionsImpressionAllocationV2
        }
      />
    );
  }

  return null;
};
